export default __webpack_public_path__ + "static/media/grandworld2.ef588b2f.jpeg";